import { env } from "@papier/env/env-frontend";
import * as Sentry from "@sentry/react";

let initialized = false;

/**
 * Browser error reporting to the tailnet-only BugSink via the same-origin
 * `/api/sentry` tunnel on the API host (the web app is static and serves no
 * API routes; BugSink has no public ingress, so browsers cannot reach it directly). No-op unless `VITE_SENTRY_DSN` is set at build time.
 */
export function initSentry() {
  if (initialized || !env.VITE_SENTRY_DSN) return;
  initialized = true;
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    tunnel: `${env.VITE_SERVERSIDE_HOST.replace(/\/$/, "")}/api/sentry`,
    environment: env.VITE_STAGE,
    release: env.VITE_GIT_COMMIT,
    tracesSampleRate: env.VITE_STAGE === "prod" ? 0.1 : 1,
    // PII is never sent: the SDK defaults to no PII collection and beforeSend
    // below strips request details down to method + path.
    beforeSend(event) {
      if (event.request) {
        event.request = {
          method: event.request.method,
          url: event.request.url?.split("?")[0],
        };
      }
      return event;
    },
  });
}

export { Sentry };
